import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { g, p, errMsg, beep } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BellRing, Check, Hand } from "lucide-react";

/** Le chiamate arrivate dai tavoli col QR: chi le prende in carico e chi le ha servite. */
export const ChiamateTavolo = () => {
  const { user, sound } = useApp();
  const [rows, setRows] = useState([]);
  const [nuove, setNuove] = useState(0);

  const load = useCallback(async () => {
    try {
      const r = await g("/calls");
      setRows(r);
      setNuove(r.length);
    } catch {
      /* rete assente: si riprova al prossimo giro */
    }
  }, []);

  useEffect(() => {
    load();
    const i = setInterval(load, 10000);
    return () => clearInterval(i);
  }, [load]);

  useEffect(() => {
    if (sound && nuove > 0) beep(true);
  }, [nuove, sound]);

  if (!rows.length) return null;

  const azione = async (id, what) => {
    try {
      await p(`/calls/${id}/${what}`, { by: user?.name || "Sala" });
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Card className="border-amber-300 bg-amber-50 p-4" data-testid="chiamate-tavolo">
      <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-amber-700">
        <BellRing className="h-3.5 w-3.5" /> Chiamate dai tavoli
      </p>
      <div className="mt-3 space-y-2">
        {rows.map((c) => (
          <div key={c.id} className="flex flex-wrap items-center gap-2 rounded-lg bg-white p-3" data-testid={`chiamata-${c.table}`}>
            <span className="font-head text-base font-bold">Tavolo {c.table}</span>
            <span className="min-w-0 flex-1 truncate text-sm text-slate-600">
              {c.label}
              {c.minutes > 0 && <span className="ml-1 text-xs text-rose-600">{c.minutes}′</span>}
              {c.claimed_by && <span className="ml-1 text-xs font-semibold text-emerald-700">→ {c.claimed_by}</span>}
            </span>
            {!c.claimed_by && (
              <Button size="sm" variant="outline" data-testid={`chiamata-claim-${c.table}`} onClick={() => azione(c.id, "claim")}>
                <Hand className="mr-1 h-3.5 w-3.5" /> Ci vado io
              </Button>
            )}
            <Button size="sm" data-testid={`chiamata-done-${c.table}`} onClick={() => azione(c.id, "done")}>
              <Check className="mr-1 h-3.5 w-3.5" /> Fatto
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
};
